import { httpGetAndParse } from '../../../../utils/fetchService';

export const fetchFederalReconciliationVariances = ({ taxYear, period, orgId, accountGroup }) =>
  httpGetAndParse({
    route: `/api/entities/federal-reconciliations/variances/${taxYear}/${period}/${orgId}/${accountGroup}`,
    errorMessage: 'Fetching federal reconciliation variances failed',
  });
